const FETCH_ADMIN_WORKS = 'fetch_adminWorks';
const FETCH_ADMIN_WORKS_CSV = 'fetch_adminWorks_csv';

const FETCH_ADMIN_WORK = 'fetch_adminWork';
const DELETE_ADMIN_WORK = 'delete_adminWork';
const PERSIST_ADMIN_WORK = 'persist_adminWork';
export default {
    FETCH_ADMIN_WORKS,
    FETCH_ADMIN_WORK,
    DELETE_ADMIN_WORK,
    PERSIST_ADMIN_WORK,
    FETCH_ADMIN_WORKS_CSV,
};
